import '../../../app.css';
import '../../../title/title.css';
import '../../game.css';

const React = require('react');
const styles = require('../../game.style').default;
const assets = require('../../../../assets').default;
const player = require('../../../../define/player').default;
const { renderTwitterButton, getTwitterText } = require('../../../../core/twitter').default;
const { getStageName, getTotalTreasure } = require('../../../../core/stageData').default;
const ModalWindow = require('../../../../core/modal').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================

export default class resultComponent extends React.Component {
    getJobImage(playerCharactor) {
        switch (playerCharactor) {
            case player.PLAYER_ROYAL_GUARD:
                return assets.CharactorRG;
            case player.PLAYER_KAGEROU:
                return assets.CharactorKG;
            default:
                return assets.CharactorSM;
        }
    }

    renderContents() {
        const { gameState: { isGameClear, playerCharactor, score, arrivalStage, totalBreakTreasure, totalPlacementPorin }, playerState: { playerName } } = this.props;
        const totalTreasure = getTotalTreasure();
        const treasureRatio = totalBreakTreasure / totalTreasure * 100;
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="tips-image-flex">
                        <img src={isGameClear ? assets.ResultClearImage : assets.ResultImage} className="tips-image" />
                    </div>
                    <div className="tips-message">
                        <div className="tips-text">
                            <div>王女メア:</div>
                            <div>王城の探索が完了しました。おつかれさまでした！</div>
                        </div>
                    </div>
                    <div className="result-center-line" >
                        <img src={this.getJobImage(playerCharactor)} className="result-image" />
                        <div className="result-charactor">{playerName}</div>
                    </div>
                    <div className="result-layout">
                        <div className="tips-text">
                            <div>王城の宝箱：{treasureRatio}% ({totalBreakTreasure} / {totalTreasure})</div>
                            <div>到達ステージ：ステージ{arrivalStage} {getStageName(arrivalStage)}</div>
                            <div>獲得コイン：{score} </div>
                            <div>使用したポリンボックス：{totalPlacementPorin} </div>
                            <div>以上です。ご協力感謝いたします。</div>
                        </div>
                    </div>

                    <div className="btn-modal-twitter">
                        {renderTwitterButton(getTwitterText(this.props))}
                    </div>
                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                            this.props.handleTitleClick()
                        }}>タイトルへ戻る</div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            isCloseOutOfArea={false}
            contents={this.renderContents()}
        />
    }
}